import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	collapsedIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandedIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	collapsedIconLabel: {
		id: 'software-releases-collapsible-ui-toggle.collapsed-icon-label',
		defaultMessage: 'Click/enter to expand the section',
		description: 'A label used for issue navigator(also known as jql search) link',
	},
	expandedIconLabel: {
		id: 'software-releases-collapsible-ui-toggle.expanded-icon-label',
		defaultMessage: 'Click/enter to collapse the section',
		description: 'A label of the more button',
	},
});
export default messages;
